import axios from 'axios';
import http from './api/http';

/**
 * Initialize the client's Axios instance with the AdReady API URL.
 * e.g., "https://platform.adready.com/api"
 *
 * This function MUST be called before any other api package imports are loaded.
 *
 * @param {String} baseURL for AdReady API
 */
export function initAxios(baseURL, config) {
  http.baseURL = baseURL;
  http.config = config;
  // initialize common axios instance with AdReady API URl
  http.AXIOS = axios.create({
    baseURL,
    withCredentials: true,
  });
}
